import { createFileRoute } from "@tanstack/react-router";
import { EditPrinterPage } from "../features/printers/edit-printer";
import { Require } from "../features/require";

/** More > Printers > a printer (P5-T24). */
export const Route = createFileRoute("/more/printers/$printerId")({ component: Page });

function Page() {
	const { printerId } = Route.useParams();
	return (
		<Require permission="printers.manage">
			<EditPrinterPage key={printerId} printerId={printerId} />
		</Require>
	);
}
